import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';
//
import { Meta } from '@angular/platform-browser';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-account-payable',
  templateUrl: './account-payable.component.html',
  styleUrls: ['./account-payable.component.css']
})
export class AccountPayableComponent implements OnInit {

  //constructor(){}
  //commentted and new code added by Digvijay on 17-06-2019
  constructor(private meta: Meta,private titleService: Title, private location: Location ) {
    this.meta.addTag({ name: 'description', content: 'Easy-to-use accounts payable software solutions that simplifies financial management. Get accounts payable automation solution for small business at best price.' },true);
    //this.meta.addTag({ name: 'description', content: 'Account Payable Software' },true);
    this.meta.addTag({ name: 'author', content: 'ShreeMon' },true);
    this.meta.addTag({ name: 'keywords', content: 'Account Payable Software,account payable software, accounts payable automation software, ap automation software' },true);
    this.titleService.setTitle('Best Accounts Payable Automation Software Solution | Shreemon');
  }

  ngOnInit() {
    this.location.replaceState("/Product/Account-Payble-Software");
  }

}
